import * as React from "react";

export const SvgArrival = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g fill={props.color ?? "#A8A8A8"}>
			<path d="M18.567 20H1.49a.682.682 0 0 1 0-1.365h17.077a.682.682 0 1 1 0 1.365ZM16.99 14.682c-.962 0-2.24-.327-3.796-.971l-2.508-1.039-5.27 1.034a.683.683 0 0 1-.45-.067L2.76 12.471a.682.682 0 0 1-.097-1.144l2.359-1.812L.989 7.159a.682.682 0 0 1-.335-.655l.57-5.887A.682.682 0 0 1 2.162.05L4.15.867c.217.09.374.285.413.517l.593 3.473 9.991 4.139c1.393.577 2.45 1.177 3.142 1.783 1.22 1.068 1.168 2.035.91 2.657-.235.569-.81 1.246-2.208 1.246Zm-6.233-3.401c.09 0 .178.017.261.052l2.698 1.117c1.37.568 2.503.868 3.275.868.78 0 .902-.294.947-.404.28-.677-.99-1.695-3.313-2.658L4.285 5.974a.682.682 0 0 1-.41-.516l-.593-3.472-.789-.324-.439 4.539 4.531 2.648a.682.682 0 0 1 .072 1.13l-2.32 1.783 1.054.558 5.235-1.027a.692.692 0 0 1 .131-.012Z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill={props.fillColor ?? "#fff"} d="M0 0h20v20H0z" />
			</clipPath>
		</defs>
	</svg>
);
